export var scoreHelper = function (event) {
    var homeScore = event.score.homeScore;
    var awayScore = event.score.awayScore;
    if (event.isTeamSwap) {
        homeScore = event.score.awayScore;
        awayScore = event.score.homeScore;
    }
    return { homeScore: homeScore, awayScore: awayScore };
};
//# sourceMappingURL=scoreHelper.js.map